<template>
  <div class="header-box">
    <img class="logo-img" alt="logo" src="@/assets/logo.jpg" />
    <span class="title">自然人电子税务局（扣缴端）</span>
    <el-tooltip
      class="item"
      effect="dark"
      content="个人所得税代扣代缴"
      placement="bottom"
    >
      <div class="withhold">
        <span class="el-icon-s-finance icon"></span>
        <span class="text">代扣代缴</span>
      </div>
    </el-tooltip>
    <div class="user-box">
      <el-popover placement="top-start" width="120" trigger="hover">
        <div slot="reference" class="user-info">
          <!--          <el-avatar :size="30" :src="avatarImgStr">-->
          <!--            <img src="@/assets/head-portrait-small.png"/>-->
          <!--          </el-avatar>-->
          <!--          <span class="user-name">{{name}}</span>-->
        </div>
        <!-- <span class="login-out" @click="handleLoginOutClick"><i class="el-icon-switch-button"></i>退出登录</span> -->
      </el-popover>
    </div>
    <div class="nav">
      <!-- <ul>
        <router-link v-for="item in filterMenuList" :key="item.id" :to="{name: item.routeUrl}" tag="li">{{item.name}}</router-link>
      </ul> -->
      <img src="../assets/zl-logo-white.png" alt="" class="zl-logo">
      <ul class="menu-group">
        <li
          class="menu-item"
          v-for="(item, index) in filterMenuList"
          :key="item.name + index"
          @click="handleExit(item.name)"
        >
          <el-tooltip
            class="item"
            effect="dark"
            :content="item.tip"
            offset="30"
            placement="bottom"
          >
            <div class="menu-item-content">
              <span class="icon" :class="item.icon"></span>
              {{ item.name }}
            </div>
          </el-tooltip>
          <!--          <div class="menu-sub-group" v-show="item.children">-->
          <!--            <div class="menu-sub-item"-->
          <!--                v-for="(subItem,index2) in item.children"-->
          <!--                :key="subItem.name+index2"-->
          <!--                @click="handleMenuClick(subItem.routeUrl, $event, subItem)">-->
          <!--              {{subItem.name}}-->
          <!--            </div>-->
          <!--          </div>-->
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { logoutApi } from "../api/UserApi";
import { MSG_MODES, MSG_TYPES, setMessage } from "../libs/message";

import { ROUTER_LOGIN } from "../router/router";
export default {
  name: "z-header",
  data() {
    return {
      filterMenuList: [
        { name: "操作手册", tip: "操作手册", icon: "el-icon-document" },
        { name: "消息中心", tip: "消息中心", icon: "el-icon-message" },
        { name: "单位管理", tip: "单位管理", icon: "el-icon-office-building" },
        { name: "离线", tip: "登录状态", icon: "el-icon-monitor" },
      ],
      hoverMenuIndex: -1,
    };
  },
  computed: {
    ...mapState("user", {
      // name: state => state.userBaseInfo.name,
      // avatarImgId: state => state.userBaseInfo.img,
      menuList: (state) => state.menuList,
      accountingStandard: (state) => state.accountingStandard,
    }),
    // avatarImgStr() {
    //   return `${process.env.BASE_API}/ctx-user/v1/files/getImage/long100/${this.avatarImgId}?token=${UserPersistence.getToken()}`;
    // }
  },
  methods: {
    // 退出按钮点击
    handleExit(name) {
      if (name === "离线") {
        this.$confirm("是否退出登录?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(()=>{
            this.$router.push({ name: ROUTER_LOGIN })
          })
          .catch(() => {});
      }
    },




    setActiveIndex(menuIndex) {
      this.hoverMenuIndex = menuIndex;
    },
    clearActiveIndex() {
      this.hoverMenuIndex = -1;
    },
    handleMenuClick(name, e, subItem) {
      this.$router.push({
        name: name,
        params: {
          id: subItem.showOrder,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/baseConfig.scss";
.header-box {
  height: 90px;
  margin: 0 auto;
  overflow: hidden;
  .logo-img {
    float: left;
    height: 100%;
  }
  .withhold {
    float: left;
    width: 70px;
    height: 70px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    margin-left: 30px;
    margin-top: 15px;
    border-radius: 4px;
    font-size: 14px;
    &.active {
      background-color: #3f7ee4;
    }
    &:hover {
      background-color: #518ff4;
      box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.15);
    }
    .icon {
      font-size: 36px;
    }
    .text {
      margin-top: 6px;
    }
  }
  .title {
    float: left;
    line-height: 80px;
    font-size: 20px;
    padding-left: 20px;
    font-weight: 500;
  }
  .accountingStandard {
    float: left;
    margin: 14px 0 0 20px;
  }
  .nav {
    float: right;
    height: 100%;
    display: flex;
    align-items: center;
    .zl-logo{
      width: 166px;
      margin-right: 20px;
    }
  }
  .user-box {
    height: 100%;
    display: flex;
    align-items: center;
    float: right;
    .user-info {
      display: flex;
      align-items: center;
      .user-name {
        display: inline-block;
        margin-left: 15px;
        max-width: 80px;
        @include text-overflow;
      }
    }
  }
}
.login-out {
  display: inline-block;
  width: 100%;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  i {
    color: red;
    margin-right: 8px;
  }
}
.login-out:hover {
  background: #5fa1f3;
  color: #fff;
}

// 菜单样式
.menu-group {
  height: 100%;
  display: flex;
  align-items: center;
  .menu-item {
    width: 90px;
    height: 60px;
    float: left;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 6px;
    margin-right: 15px;
    position: relative;
    font-size: 14px !important;
    &:hover {
      background-color: #518ff4;
      border-radius: 4px;
    }
    .menu-item-content {
      height: 60px;
      line-height: 60px;
      cursor: default;
      .icon {
        font-size: 20px;
      }
    }
    .active {
      color: #3a7dd1;
      font-weight: bold;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/z-header.vue